@if (isMarketSelectorActive && isMarketSwitcherConfigured && eventsBySectionsCopy.length) {
    <lazy-component
        class="sticky-market-selector"
        moduleUri="@sharedModule/components/marketSelector/market-selector.module#MarketSelectorModule"
        data-crlat="marketSelectorModule"
        entryComponent="MatchesMarketSelectorComponent"
        [inputs]="{ sportId: sportId, multipleEventsDataSections: eventsBySectionsCopy, selectorType: 'sportMatches', targetTab: targetTab }"
        [outputs]="['filterChange', 'hideEnhancedSection']"
        (event)="handleOutput($event)">
    </lazy-component>
}
@if (isLoaded && !isResponseError && (eventsBySections.length || enhancedEvents.length)) {
    <lazy-component
        moduleUri="@lazy-modules-module/twoUpSignpostingBlurbMsg/twoup-signposting-blurbmsg.module#TwoUpSignPostingBlurbMsgModule"
        [inputs]="{
            marketName: selectedMarketSwitcher,
        }"
        entryComponent="TwoUpSignPostingBlurbMsgComponent">
    </lazy-component>

    <!-- Enhanced Multiples Events -->
    @if (isLoadedEnhanced && enhancedEvents.length && groupedByDateEnhancedEvents) {
        <accordion
            data-crlat="accordion"
            [isExpanded]="isExpandedEnhanced"
            [trackLabel]="'expand'"
            [trackCategory]="'upcoming module'"
            [trackAction]="locationPath"
            (function)="updateState($event, 'enhanced')"
            [trackExpandOnly]="true"
            [class]="'matches-card'">
            <left-side>
                <span class="left-title-text" [textContent]="'Enhanced Multiples'" data-crlat="headerTitle.leftMessage"></span>
            </left-side>
            @if (isExpandedEnhanced) {
                <accordion-body>
                    @for (
                        enhancedEventsGroup of groupedByDateEnhancedEvents.groupedByDate;
                        track trackByDate(i, enhancedEventsGroup);
                        let i = $index
                    ) {
                        <div class="container-inner-content" data-crlat="containerInnerContent">
                            @if (enhancedEventsGroup.events?.length) {
                                <odds-card-header
                                    [events]="enhancedEventsGroup.events"
                                    [sportConfig]="sport?.sportConfig"
                                    data-crlat="eventOddsHeader"
                                    [dateTitle]="enhancedEventsGroup.title"
                                    [isFilterByTemplateMarketName]="true"
                                    [hideOddsTitles]="true"
                                    [class]="'matches-card'">
                                </odds-card-header>
                            }
                            @for (eventEntity of enhancedEventsGroup.events; track trackById(i, eventEntity); let i = $index) {
                                @if (eventEntity.markets[0].outcomes.length) {
                                    <odds-card-component
                                        data-crlat="eventEntity"
                                        [sportConfig]="sport?.sportConfig"
                                        [event]="eventEntity"
                                        [gtmModuleTitle]="'Enhanced Multiples'"
                                        (goToEventCallback)="trackEvent(eventEntity)">
                                    </odds-card-component>
                                }
                            }
                        </div>
                    }
                </accordion-body>
            }
        </accordion>
    }
    @if (isMarketSwitcherComponentLoaded) {
        @for (eventsBySection of eventsBySections; track trackByTypeId(i, eventsBySection); let i = $index) {
            @if (!eventsBySection.deactivated) {
                <ng-template *ngTemplateOutlet="VirtualBanner; context: { index: activeIndex(i) }"></ng-template>
            }

            <!--main sport events sections-->
            @if (!eventsBySection.deactivated) {
                <accordion
                    data-crlat="accordion"
                    [accordionTitle]="eventsBySection.sectionTitle"
                    (function)="updateState($event, 'event', eventsBySection)"
                    [isExpanded]="eventsBySection.isExpanded"
                    [class]="'matches-card'"
                    [trackLabel]="'expand'"
                    [trackCategory]="'upcoming module'"
                    [trackExpandOnly]="true"
                    [trackAction]="locationPath">
                    <right-side>
                        @if (eventsBySection.isExpanded) {
                            <see-all-link
                                [targetTab]="targetTab"
                                [sportId]="sportId"
                                [eventType]="eventsBySection.typeName"
                                (click)="goToCompetition(eventsBySection)"></see-all-link>
                        }
                    </right-side>
                    @if (eventsBySection.isExpanded) {
                        <accordion-body>
                            @for (eventsGroup of eventsBySection.groupedByDate; track trackByDate(groupIndex, eventsGroup); let groupIndex = $index) {
                                <div class="container-inner-content" data-crlat="containerInnerContent">
                                    @if (
                                        isPrimaryMarket(eventsBySection) ||
                                        checkMarketsAvailability(eventsGroup, eventsBySection.defaultValue?.toLowerCase())
                                    ) {
                                        @if (eventsGroup.events?.length) {
                                            <odds-card-header
                                                [events]="eventsGroup.events"
                                                [sportConfig]="sport?.sportConfig"
                                                data-crlat="eventOddsHeader"
                                                [dateTitle]="eventsGroup.title"
                                                [isFilterByTemplateMarketName]="true"
                                                [isMarketSwitcherConfigured]="isMarketSwitcherConfigured"
                                                [selectedMarket]="selectedMarket(eventsBySection)"
                                                [undisplayedMarket]="undisplayedMarket"
                                                [class]="'matches-card'">
                                            </odds-card-header>
                                        }
                                        @for (eventEntity of eventsGroup.events; track trackById(i, eventEntity); let i = $index) {
                                            @if (eventEntity.markets[0]?.outcomes?.length) {
                                                <odds-card-component
                                                    data-crlat="eventEntity"
                                                    [sportConfig]="sport?.sportConfig"
                                                    [event]="eventEntity"
                                                    [selectedMarket]="selectedMarket(eventsBySection)"
                                                    [isFilterByTemplateMarketName]="true"
                                                    [isMarketSwitcherConfigured]="isMarketSwitcherConfigured"
                                                    [markets]="eventEntity.markets"
                                                    [gtmModuleTitle]="eventsBySection.sectionTitle"
                                                    (marketUndisplayed)="reinitHeader($event)"
                                                    (goToEventCallback)="trackEvent(eventEntity)">
                                                </odds-card-component>
                                            }
                                        }
                                    }
                                </div>
                            }
                        </accordion-body>
                    }
                </accordion>
            }
        }
        <ng-container>
            <ng-template *ngTemplateOutlet="VirtualBanner; context: { index: activeIndex(eventsBySections.length) }"></ng-template>
        </ng-container>
    }
}
@if (isLoaded && isResponseError && !featuredEventsCount) {
    <request-error (reloadFn)="loadMatchesData()" [loadFailed]="isResponseError"> </request-error>
}
@if (isLoaded && !isResponseError && !eventsBySections.length && !enhancedEvents.length && (!featuredEventsCount || timeFilter || leagueFilter)) {
    <no-events> </no-events>
}
@if (isLoaded && (!eventsBySections.length || (eventsBySections.length && !isMarketSwitcherComponentLoaded))) {
    <ng-template *ngTemplateOutlet="VirtualBanner; context: { index: -1 }"></ng-template>
}

<ng-template #VirtualBanner let-index="index">
    @if (isLoaded && targetTab?.interstitialBanners?.bannerEnabled) {
        <virtual-entry-point-banner
            [targetTab]="targetTab"
            [eventsBySections]="eventsBySections"
            [sportName]="sportName"
            [index]="index"></virtual-entry-point-banner>
    }
</ng-template>
@if (isDisplayTutorial) {
    <football-tutorial-overlay></football-tutorial-overlay>
}
